import Layout from '@/components/Layout'
import Seo from '@/components/Seo'
import { whatsappLink, whatsappMessages } from '@/lib/site-data'
import {MessageCircleDashed as MessageCircle} from 'lucide-react'

function PoliticaGarantia() {
  return (
    <Layout>
      <Seo
        title="Política de Garantia | Muita Mídia"
        description="Conheça a política de garantia de 7 dias da Muita Mídia para a compra de páginas do Instagram, conforme o Código de Defesa do Consumidor."
        path="/politica-de-garantia"
      />

      <section className="bg-white">
        <div className="mx-auto max-w-3xl px-6 py-16 sm:py-20">
          <h1 className="text-3xl font-bold text-zinc-900">Política de Garantia</h1>
          <p className="mt-3 text-sm text-zinc-500">Última atualização: janeiro de 2024</p>

          <div className="mt-8 space-y-8 text-base leading-relaxed text-zinc-700">
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">1. Prazo de garantia</h2>
              <p className="mt-2">
                Todas as páginas vendidas pela Muita Mídia possuem garantia de 7 (sete) dias corridos, contados a
                partir da entrega das credenciais de acesso, conforme previsto no Código de Defesa do Consumidor (Lei
                nº 8.078/1990).
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">2. O que a garantia cobre</h2>
              <p className="mt-2">
                Dentro do prazo de 7 dias, o cliente pode solicitar o reembolso integral do valor pago pela página,
                desde que o perfil esteja nas mesmas condições em que foi entregue, sem alterações relevantes.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">3. Condições que invalidam a garantia</h2>
              <p className="mt-2">
                A garantia de 7 dias é válida apenas enquanto o perfil permanecer nas condições originais de entrega.
                Alterações como mudança de nome de usuário (@), nome de exibição, foto de perfil ou biografia tornam a
                compra definitiva e impossibilitam o pedido de reembolso.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">4. Como solicitar o reembolso</h2>
              <p className="mt-2">
                Para acionar a garantia, o cliente deve entrar em contato pelo WhatsApp dentro do prazo de 7 dias,
                informando o motivo da solicitação. Nossa equipe irá verificar as condições do perfil antes de
                confirmar o reembolso.
              </p>
            </div>
            <div>
              <h2 className="text-lg font-semibold text-zinc-900">5. Suporte durante o prazo de garantia</h2>
              <p className="mt-2">
                Durante os 7 dias de garantia, o cliente também tem acesso ao nosso suporte pós-venda pelo WhatsApp
                para dúvidas técnicas sobre acesso, senha, e-mail vinculado e demais etapas da transferência.
              </p>
            </div>
          </div>

          <div className="mt-10 rounded-2xl border border-zinc-100 bg-zinc-50 p-6">
            <p className="text-sm text-zinc-600">Ficou com alguma dúvida sobre a garantia? Fale direto com a nossa equipe.</p>
            <a
              href={whatsappLink(whatsappMessages.contactCta)}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-semibold text-white transition-transform hover:scale-105"
            >
              <MessageCircle className="h-4 w-4" fill="white" strokeWidth={0} />
              Falar no WhatsApp
            </a>
          </div>
        </div>
      </section>
    </Layout>
  )
}

export default PoliticaGarantia
